import { isUSRegion } from '@/i18n/country'

export type AssetNavSection = 'crypto' | 'stocks'

/**
 * WWW-5191: 详情页面包屑的 Market 链接。
 * US region 下首页（HomepageV2）由 ?asset_nav= 驱动切换区块且 CMS 默认 tab
 * 是 predictions，裸 href 会落到 predictions；这里按详情页来源带上对应 tab。
 * 非 US region 保持 '/'（自动拼 BASE_PATH → /{locale}/price）。
 */
export function getMarketBreadcrumbHref(locale: string | undefined, section: AssetNavSection) {
  if (!locale || !isUSRegion(locale)) return '/'
  return `/?asset_nav=${section}`
}
